import { gql } from '@apollo/client/core';

export const CLOSE_ACCOUNT = gql`
  mutation closeAccount {
    closeAccount {
      isSuccessful
    }
  }
`;

export const CLOSE_JOB = gql`
  mutation closeJob($id: UUID!) {
    closeJob(id: $id) {
      id
    }
  }
`;

export const CREATE_SITTER = gql`
  mutation createSitter($input: CreateSitterInput!) {
    account {
      createSitter(input: $input) {
        token
        refreshToken
        account {
          id
        }
      }
    }
  }
`;

export const UPDATE_ADDRESS = gql`
  mutation updateAddress($address: PostalAddressInput!) {
    account {
      updateAddress(address: $address) {
        id
      }
    }
  }
`;

export const UPDATE_PARENT = gql`
  mutation updateParent($careType: CareType, $postalAddress: PostalAddressInput) {
    updateParent(input: { careType: $careType, postalAddress: $postalAddress }) {
      id
    }
  }
`;

export const UPDATE_QUESTIONNAIRE_RESULT = gql`
  mutation updateQuestionnaireResult($input: UpdateQuestionnaireResultInput!) {
    updateQuestionnaireResult(input: $input) {
      isSuccessful
      problems {
        message
      }
    }
  }
`;

export const SEND_VERIFICATION_EMAIL = gql`
  mutation sendVerificationEmail {
    account {
      sendVerificationEmail {
        success
      }
    }
  }
`;
